<img [hfSrcset]="file?.folder + '/' + file?.thumbnail" [alt]="file?.originalFilename" class="image" />
